//alert('hello world')

/*============================================================================
  UI PURCHASE DRAWER
==============================================================================*/

function openDrawer(screen) {
	const drawer = document.getElementById('purchase-drawer' + screen);
	drawer.setAttribute("open", "");
	initSelections(drawer);
}

function closeDrawer(screen) {
	screen.removeAttribute("open");
}

function closeDrawers() {
	let drawers = document.querySelectorAll('purchase-drawer');
	drawers.forEach(function(elem) {
	   elem.removeAttribute("open");
	});
}


/*============================================================================
  ADD TO CART CLASSIC
==============================================================================*/

function simpleAdd() {
	let addToCartForm = document.getElementById('MainPaymentContainer').closest('form');
	let formData = new FormData(addToCartForm);

	console.log(formData);

	fetch(window.Shopify.routes.root + 'cart/add.js', {
	  method: 'POST',
	  body: formData
	})
	.then(response => {
	  return response.json();
	  //console.log(response.json);
	})
	.then(response => {
		closeDrawers();
		document.getElementById('mini-cart').open = true;
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true
		}));
		/* Update Package ID value randomly */
		updatePackage();
	})
	.catch((error) => {
	  console.error('Error:', error);
	});
}


/*============================================================================
  ADD TO CART WITH OPTIONS
==============================================================================*/

function journeyAdd() {

  /* Init objects */
  var items = [],
      mainProps = {},
      optionsHandles = '',
      optionsID = '';

  /* Init global var for package */
  var package = document.querySelector('input[name="properties[_package_id]"]').value;

  /* Add checked options for main product */

  var selectedOptions = document.querySelectorAll('input.optional-input:not(.ux-only):checked');

	selectedOptions .forEach(function(variant) {

    var name = variant.dataset.inName,
        value = variant.dataset.inValue,
        handle = variant.dataset.handle;

    mainProps[name] = value;
    optionsHandles = optionsHandles + ' # ' + handle;

    var variantID = parseInt(variant.dataset.id),
        qty = parseInt(variant.dataset.qty),
        price = variant.dataset.price,
        propTitle = variant.dataset.propTitle,
        propValue = variant.dataset.propValue,
        propAssociated = variant.dataset.mainHandle,
        propAssociatedID = variant.dataset.mainId,
        propAssociatedsku = variant.dataset.sku;

    /* Add real product only if price is greater than 0 */
    if(price > 0) {
      optionsID = optionsID + variantID + ',';
      var item = {'id': variantID,'quantity': qty,properties:{'_type': 'optionProduct', '_package_id': package, [propTitle]: propValue, '_associated':propAssociated, '_parentID':propAssociatedID, '_ratio':qty}}
      items.push(item);
    }

	});

	/* Properties for ordonnance upload if needed */
  var ukContainer = document.querySelector('.uploadkitContainer');
  var ukConfirmText = ukContainer.dataset.propConfirm;
  var ukLinkText = ukContainer.dataset.propLink;
  var ukYes = ukContainer.dataset.propYes;
  var ukNo = ukContainer.dataset.propNo;

  if (ukContainer && document.querySelector('.fileAttached').checked) {
    /* Find input generated by UploadKit */
    var ukField = document.querySelector('.uploadkit .uploadkit-attribute-container input');
    var optionField = document.querySelector('.fileAttached');
    if (ukField && optionField.checked) {
      /* Props if field exists */
      mainProps[ukConfirmText] = ukYes;
      mainProps[ukLinkText] = ukField.value;
    } else {
      mainProps[ukConfirmText] = ukNo;
    }
  } else {
      mainProps[ukConfirmText] = ukNo;
  }

  /* Add main product to items object with package id prop and variants, qty 1 */

  var mainForm = document.getElementById('MainPaymentContainer').closest('form');
  var mainID = mainForm.querySelector('input[name="id"]').value;
  var altImg = '';
  mainProps['_package_id'] = package;

  if (document.querySelector('input[name="' + mainID + '"]')) {
  	var alternativeID = document.querySelector('input[name="' + mainID + '"]').dataset.dumb;
  } else {
  	var alternativeID = mainID;
  }

  if (alternativeID == 'unavailable') {
  	var finalID = mainID;
  } else {
  	var finalID = alternativeID;
  	if(document.querySelector('input[name="properties[_originalProduct]"]')) {
	  	/* Store original product handle to display associated datas in cart and account in case DUMB is added to cart instead of main product */
	  	originalProduct = document.querySelector('input[name="properties[_originalProduct]"]').value;
	  	mainProps['_originalProduct'] = originalProduct;
  	}
  }

  /* Then push main product to items object */
  var mainItem = {'id': finalID, 'quantity': 1, properties:mainProps};

  items.push(mainItem);

  console.log(items);

  let formData = {
   'items': items
  };

	fetch(window.Shopify.routes.root + 'cart/add.js', {
	  method: 'POST',
	  headers: {
	    'Content-Type': 'application/json'
	  },
	  body: JSON.stringify(formData)
	})
	.then(response => {
	  return response.json();
	  //console.log(response.json);
	})
	.then(response => {
		closeDrawers();
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true
		}));
		document.getElementById('mini-cart').open = true;

		/* Update Package ID value randomly */
		updatePackage();
	})
	.catch((error) => {
	  console.error('Error:', error);
	});
	//alert('add all to cart');
}


/*============================================================================
  PURCHASE JOURNEY OPTIONS AS VARIANT SELECTED UPDATE
==============================================================================*/

function initSelections(drawer) {
	const firstOption = drawer.querySelector('.option-values--value input');
	if (firstOption) { updateSelected(firstOption); return; }
	if (drawer.querySelector('input.optional-input:not(.ux-only)')) {
		updateOptionsSummaryList(drawer);
		calcProductPrice(drawer);
	}
}

function updateSelected(elem) {

	var selectVariantID = '#variant';
	var drawer = elem.closest('purchase-drawer');
	var selectedOptions = drawer.querySelectorAll('.optional-input.ux-only:checked');

	cleanChecks();

	selectedOptions.forEach(function(checked) {
      var thisVal = checked.value;
      selectVariantID = selectVariantID + thisVal;
	});

	var selectedVariants = drawer.querySelectorAll('.option-list .variant-block');
	selectedVariants.forEach(function(variant) {
		variant.checked = false;
	});

	selectVariantID = selectVariantID.replace(/\s/g,'');
	if (drawer.querySelector(selectVariantID) != null) {
		drawer.querySelector('.unavailable-variant-message').classList.add('hide-content');
		drawer.querySelector('.updateSelectedVariant').classList.remove('hide-content');
		drawer.querySelector(selectVariantID).checked = true;
		//alert(selectVariantID);
	} else {
		drawer.querySelector('.unavailable-variant-message').classList.remove('hide-content');
		drawer.querySelector('.updateSelectedVariant').classList.add('hide-content');
	}

	updateOptionsSummaryList(drawer);
	calcProductPrice(drawer);

}


/*============================================================================
  UTILITIES
==============================================================================*/

function cleanChecks() {
	var variantsToClean = document.querySelectorAll('input.optional-input:not(.ux-only):checked');

	variantsToClean.forEach(function(variant) {
		variant.checked = false;
	});
}

function updatePackage() {

	var packInputs = document.querySelectorAll('input[name="properties[_package_id]"]');
	let packID = packInputs[0].value;
	var newPackID = parseInt(packID) + Math.floor(Math.random() * 10) + 1;

	/* Checkpoint : the generated ID must not collide with a package already in the cart */
	var packagesData = document.querySelector('packages-data');
	if (packagesData) {
		var cartPackages = packagesData.dataset.ids.split(',').map(function(id) {
			return parseInt(id);
		});
		while (cartPackages.includes(newPackID)) {
			newPackID = newPackID + Math.floor(Math.random() * 99) + 1;
		}
	}

	packInputs.forEach(function(input) {
		input.value = newPackID;
	});

}


/*============================================================================
  PRICE FORMAT
==============================================================================*/

function formattedPrice(price) {
  var moneyFormat = document.getElementById('formatMoney').dataset.format;
  var formattedPrice = Shopify.formatMoney(price,moneyFormat);
  return formattedPrice;
}


/*============================================================================
  PRICE CALCULATOR
==============================================================================*/

function calcProductPrice(drawer) {
	var priceBtn = drawer.querySelector('.priceCalculator');
	if (!priceBtn) return;
	var price = parseInt(priceBtn.dataset.initPrice);

	var options = drawer.querySelectorAll('input.optional-input:not(.ux-only):checked');
	options.forEach(function(option) {
		price = price + (parseInt(option.dataset.price) * parseInt(option.dataset.qty));
	});

	var allDrawers = Array.from(document.querySelectorAll('purchase-drawer'));
	var drawersToUpdate = allDrawers.slice(allDrawers.indexOf(drawer));

	drawersToUpdate.forEach(function(d) {
		var btn = d.querySelector('.priceCalculator');
		if (btn) btn.innerHTML = formattedPrice(price);
	});
}


/*============================================================================
  OPTIONS SUMMARY LIST UPDATE
==============================================================================*/

function updateOptionsSummaryList(drawer) {
	var template = document.getElementById('purchase-option-template');
	var options = drawer.querySelectorAll('input.optional-input:not(.ux-only):checked');
	var allDrawers = Array.from(document.querySelectorAll('purchase-drawer'));
	var drawersToUpdate = allDrawers.slice(allDrawers.indexOf(drawer));
	var uploadDrawer = document.querySelector('#purchase-drawerupload');
	if (uploadDrawer && !drawersToUpdate.includes(uploadDrawer)) {
		drawersToUpdate.push(uploadDrawer);
	}

	var uxTitles = [];
	drawer.querySelectorAll('.optional-input.ux-only:checked').forEach(function(ux) {
		var titleEl = ux.closest('label').querySelector('.variant-block-title');
		if (titleEl) uxTitles.push(titleEl.textContent.trim());
	});

	drawersToUpdate.forEach(function(d) {
		var datas = d.querySelector('.purchase-summary--datas');
		if (!datas) return;

		datas.querySelectorAll('.purchase-summary--option').forEach(function(el) { el.remove(); });

		options.forEach(function(option) {
			var line = template.content.cloneNode(true);

			line.querySelector('.option-product-name').textContent = option.dataset.inName;
			var ul = line.querySelector('.option-details');
			var variantLi = ul.querySelector('.option-detail--variant');
			if (variantLi) {
				if (option.dataset.inValue) {
					variantLi.textContent = option.dataset.inValue;
					variantLi.classList.remove('hide-content');
				} else {
					variantLi.classList.add('hide-content');
				}
			}
			uxTitles.forEach(function(title) {
				var li = document.createElement('li');
				li.textContent = title;
				ul.appendChild(li);
			});

			if (option.dataset.color) {
				var colorBlock = line.querySelector('.option-image--color');
				var originalSwatch = option.closest('label').querySelector('.color-option--border');
				if (originalSwatch) {
					colorBlock.innerHTML = '';
					colorBlock.appendChild(originalSwatch.cloneNode(true));
				} else {
					colorBlock.querySelector('.color-option--color').style.background = option.dataset.color;
					colorBlock.querySelector('.color-option--border').style.borderColor = option.dataset.color;
				}
				//colorBlock.classList.remove('hide-content');
			} /*else if (option.dataset.image) {
				var photoBlock = line.querySelector('.option-image--photo');
				if (photoBlock) {
					photoBlock.querySelector('img').src = option.dataset.image;
					photoBlock.querySelector('img').alt = option.dataset.inName;
					photoBlock.classList.remove('hide-content');
				}
			}*/

			if (parseInt(option.dataset.price) === 0) {
				line.querySelector('.option-price--free').classList.remove('hide-content');
			} else {
				line.querySelector('.option-price--amount').textContent = option.dataset.priceMoney;
			}

			datas.appendChild(line);
		});
	});
}


/*============================================================================
  SUMMARY PAGE MANAGEMENT
==============================================================================*/

function updateSummary(elem) {
  var currentWindow = elem.closest('purchase-drawer');

  var variantsTarget = document.querySelector('.summary-variants');
  variantsTarget.innerHTML = '';

  var variantTitle = document.querySelector('.summary-title-variant');
  var variantPrice = document.querySelector('.summary-price-variant');

  /* Exit if doesn't exist */
	if (!variantsTarget || !variantTitle || !variantPrice) return;

  if (currentWindow.querySelectorAll('.colorOptionVariants').length > 0) {

    var selectedVariant = currentWindow.querySelector(':checked');
    var selectedOption = currentWindow.querySelector('.optional-input-color:checked + .color-option-block .variant-option--name').textContent;
    var selectedVariantTitle = selectedVariant.dataset.inName;

    variantTitle.textContent = selectedVariantTitle;
    variantsTarget.innerHTML = selectedOption;
    variantPrice.textContent = selectedVariant.dataset.priceMoney;

  } else {
    var selectedOptions = currentWindow.querySelectorAll('.ux-only:checked + .radio-label .variant-block-title');

    var selectedVariant = currentWindow.querySelector('.optional-variant:checked');
    //console.log(selectedVariant);

    if (selectedVariant) {
    	variantTitle.textContent = selectedVariant.dataset.inName;
    	variantPrice.textContent = selectedVariant.dataset.priceMoney;
    }

    for (var i = 0; i < selectedOptions.length; i++) {
        const node = document.createElement("option");
        const textnode = document.createTextNode(selectedOptions[i].textContent.trim());
        node.appendChild(textnode);
        variantsTarget.appendChild(node);
    }
  }

  var uploadTarget = document.querySelector('.summary-title-upload');
  uploadTarget.textContent = document.querySelector('#purchase-drawerupload input:checked').value;;
}

function summaryManager() {

  var btns = document.getElementsByClassName('updateSummary');

  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function (e) {
      updateSummary(this);
    });
  }

  var uploadWindow = document.querySelector('#purchase-drawerupload');
  if(uploadWindow) {
    var summaryBtn = uploadWindow.querySelector('.updateSummary');
    if (summaryBtn) {
      summaryBtn.addEventListener("click", function (e) {
        //Find inputs generated by UploadKit
        var ukField = document.querySelector('.uploadkit .uploadkit-attribute-container input');
        var optionField = document.querySelector('.fileAttached');
        if (ukField && optionField.checked) {
          document.querySelector('.summary-title-upload').textContent = document.querySelector('.uploadkit-button-uploaded').textContent;
        } else {
          document.querySelector('.summary-title-upload').textContent = document.querySelector('.hideUpload input').value;
        }
      });
    }
  }

}


function updateColorRecap(input) {
	var container = input.closest('.options-container');
	if (!container) return;
	var recap = container.querySelector('.color-selection-recap');
	if (!recap) return;
	recap.querySelector('.color-recap--swatch').style.background = input.dataset.color || '';
	recap.querySelector('.color-recap--info').textContent = (input.dataset.propValue || '') + (input.dataset.inValue ? ' · ' + input.dataset.inValue : '');
	recap.querySelector('.color-recap--price').textContent = input.dataset.priceMoney || '';
	recap.classList.remove('hide-content');
}

function showColorVariants(colorLink, colorVariants) {
	colorVariants.forEach(function(v){
		v.style.display = 'none';
		v.classList.remove('colorVariantsVisible');
	});
	let target = document.querySelector('#' + colorLink.dataset.target);
	target.style.display = 'flex';
	target.classList.add('colorVariantsVisible');
	var titleProduct = colorLink.closest('.options-container') ? colorLink.closest('.options-container').querySelector('.option-title--product') : null;
	if (titleProduct && colorLink.dataset.title) {
		titleProduct.textContent = colorLink.dataset.title.toLowerCase();
	}
}

/*============================================================================
  INIT — EVENT LISTENERS
==============================================================================*/

function initPurchaseDrawer() {

	const openJourney = document.getElementById('purchase-journey');
	const openJourneySticky = document.querySelector('#purchase-journey-sticky');
	let prevScreens = document.querySelectorAll('.previous-drawer');
	let closers = document.querySelectorAll('.purchase-close');
	let nextScreens = document.querySelectorAll('.purchase-next');

	if(openJourney) {
		openJourney.addEventListener("click", function (e) {
		  	openDrawer(1);
		});
	}

	if(openJourneySticky) {
		openJourneySticky.addEventListener("click", function (e) {
		  	openDrawer(1);
		});
	}

	closers.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			closeDrawers();
		});
	});

	prevScreens.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			const screen = this.closest('purchase-drawer');
			closeDrawer(screen);
		});
	});

	nextScreens.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			const screen = this.dataset.next;
			openDrawer(screen);
		});
	});

	let purchaseAdds = document.querySelectorAll('.purchase-addClassic');
	purchaseAdds.forEach(function(elem) {
		elem.addEventListener("click", function (evt) {
			if(!evt.target.classList.contains('choiceBasic')) {
				simpleAdd();
			}
		});
	});

	if(document.querySelector('.purchase-addJourney')) {
		document.querySelector('.purchase-addJourney').addEventListener("click", function (e) {
			journeyAdd();
		});
	}

	let colorLinks = document.querySelectorAll('.colorOptionLink');
	let colorVariants = document.querySelectorAll('.colorOptionVariants');
	colorLinks.forEach(function(color) {
		color.addEventListener('click', function(e) {
			colorLinks.forEach(function(c){ c.classList.remove('active'); });
			color.classList.add('active');
			showColorVariants(color, colorVariants);
			var target = document.querySelector('#' + color.dataset.target);
			var firstRadio = target ? target.querySelector('.optional-input-color') : null;
			if (firstRadio) {
				cleanChecks();
				firstRadio.checked = true;
				var drawer = firstRadio.closest('purchase-drawer');
				updateOptionsSummaryList(drawer);
				calcProductPrice(drawer);
				updateColorRecap(firstRadio);
			}
		});
		color.addEventListener('mouseenter', function(e) {
			showColorVariants(color, colorVariants);
		});
		color.addEventListener('mouseleave', function(e) {
			let activeLink = document.querySelector('.colorOptionLink.active');
			if (activeLink) showColorVariants(activeLink, colorVariants);
		});
	});

	var colorSelectedVariants = document.querySelectorAll('.optional-input-color');
	colorSelectedVariants.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			cleanChecks();
			elem.checked = true;
			updateOptionsSummaryList(elem.closest('purchase-drawer'));
			calcProductPrice(elem.closest('purchase-drawer'));
			updateColorRecap(elem);
		});
	});
	var initialColorInput = document.querySelector('.optional-input-color:checked');
	if (initialColorInput) updateColorRecap(initialColorInput);

	let optionRadios = document.querySelectorAll('.option-values--value input');
	optionRadios.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			updateSelected(elem);
		});
	});

	let optionUpdates = document.querySelectorAll('.updateSelectedVariant');
	optionUpdates.forEach(function(elem) {
		elem.addEventListener("click", function (e) {
			updateSelected(elem);
		});
	});

	if(document.querySelector('.showUpload')) {
		document.querySelector('.showUpload').addEventListener('click', function (e) {
			document.querySelector('.uploadkitContainer').classList.add('open');
		});
		document.querySelector('.hideUpload').addEventListener('click', function (e) {
			document.querySelector('.uploadkitContainer').classList.remove('open');
		});
	}

	summaryManager();

}

initPurchaseDrawer();

document.addEventListener('shopify:section:load', function() {
	initPurchaseDrawer();
});




/*============================================================================
  NON RELATED TO PURCHASE FUNNEL BELOW
==============================================================================*/


/*============================================================================
  VARIANT ACCORDION UPDATE
==============================================================================*/

document.addEventListener('variant:changed', function(event) {
	let variantId = event.detail.variant.id; // Gives you access to the whole variant details
	let varContents = document.querySelectorAll('.variantContent');
	varContents.forEach(function(elem) {
		if (elem.dataset.variant == variantId) {
			elem.classList.remove('hide-content')
		} else {
			elem.classList.add('hide-content');
		}
	});
});



/*============================================================================
  FITTING BOX
==============================================================================*/

/*================ FIRST CHECK IF MODULE EXISTS & PRODUCT AVAILABILITY USING API ===============*/

var viewModule;

if(document.querySelector('.fittin-btns-container')) {

		async function getAvailability(sku) {
		  // Put your apiKey as an environment Variable
		    const apiKey = "3JgpOqH8nJ2sKAbrplbDGzzKYVfJFbTf8WUO3QrJ"
		    const url = 'https://product-api.fittingbox.com/glasses-metadata/availability?apiKey='+ apiKey + '&uidList=' + sku +''
		  try {
		    const response = await fetch(url);
		    if (!response.ok) {
		      throw new Error(`Response status: ${response.status}`);
		    }

		    const availability = await response.json();
		    return availability[0]['available'];
		  } catch (error) {
		    console.error(error.message);
		  }
		}

		async function main() {
		  let sku = document.querySelector('.button--try').dataset.sku
		    try {
		        const availabilityResult = await getAvailability(sku)
		        if(availabilityResult) {

		        	/* Show buttons */
		        	document.querySelector('.button--try').classList.remove('hide-content');
		        	document.querySelector('.button--3d').classList.remove('hide-content');

							/* Start VTO... */
							var params = {
							  apiKey: '3JgpOqH8nJ2sKAbrplbDGzzKYVfJFbTf8WUO3QrJ',
							  frame: sku,
							};

							/* IN Carrousel */
							/*viewModule = FitMix.createWidget('fittinMedia', params, onViewReady);
							tryModule = FitMix.createWidget('blockfittin', params, onTryReady);
							function onViewReady() {
									viewModule.startVto('viewer');
							}
							function onTryReady() {
									tryModule.startVto('live');
							}	*/

		        } else {

		        	/* Remove 3d thumbnail if not available */
		        	document.querySelector('.fittinMediaThumbnail .product__thumbnail-badge').remove();
		        }



		    } catch(err) {
		        // Handle fetch error
		    }
		}

		main()


		function openTry() {
			  var tryWindow = document.querySelector('product-try');
			  tryWindow.classList.add('pswp--open');
			  tryWindow.setAttribute("open", "");
		}

		function closeTry() {
			  var tryWindow = document.querySelector('product-try');
			  tryWindow.classList.remove('pswp--open');
			  tryWindow.removeAttribute("open");
		}

		function loadTry(sku,handle,action,source) {

			if(source == 'carrousel') {
				var css_src = document.querySelector('body').dataset.fitCss;
			} else {
				var css_src = ''
			}
		  var params = {
		        apiKey: '3JgpOqH8nJ2sKAbrplbDGzzKYVfJFbTf8WUO3QrJ',
		        frame: sku,
		        onStopVto: initCarrousel3d,
		        css: css_src,
		  };

			if (source == 'btn') {
				fitmixInstance = FitMix.createWidget('blockfittin', params, onFitMixReady);
				function onFitMixReady() {
					fitmixInstance.startVto(action);
				}
			}

			if (source == 'carrousel') {
				fitmixCarousel = FitMix.createWidget('fittinMedia', params, on3dReady);
				function on3dReady() {
					fitmixCarousel.startVto(action);
				}
			}

		}

		function initCarrousel3d() {
			var container3d = document.getElementById('fittinMedia');
			if(container3d) {
				let sku = container3d.dataset.sku;
				let handle = container3d.dataset.handle;
				let action = container3d.dataset.action;
					loadTry(sku,handle,action,'carrousel');
			}
		}
		initCarrousel3d();


		document.querySelector('.button--try').addEventListener("click", function (e) {
			openTry();
			let sku = this.dataset.sku;
			let handle = this.dataset.handle;
			let action = this.dataset.action;
			loadTry(sku,handle,action,'btn');
		});


			document.querySelector('.button--3d').addEventListener("click", function (e) {
				openTry();
				let sku = this.dataset.sku;
				let handle = this.dataset.handle;
				let action = this.dataset.action;
				loadTry(sku,handle,action,'btn');
			});


		let tryClose = document.querySelector('.button--try--close');
			tryClose.addEventListener("click", function (e) {
				  closeTry();
				  fitmixInstance.stopVto();
			});

		let tryBgClose = document.querySelector('.product-try__bg');
			tryBgClose.addEventListener("click", function (e) {
				  closeTry();
				  fitmixInstance.stopVto();
			});

}
